import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import {
  TagsSearchModalContainer,
  TagsSearchScrollWrapper,
} from "./styles.mobile";
import { CategoryHeader } from "./CategoryHeader";
import { useDispatch } from "react-redux";
import { TagsActions } from "shared/reducers/Tags";
import { EmptyTextWrapper } from "./FoundTags";
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import { TagsSearchTitle } from "./styles.mobile";
import CloseIcon from "../../icons/CloseIcon";
import { useModal } from "../../../core";
import { AppTester } from 'supporting';
import { TagsSearchInputComponent } from "./components/TagsSearchInputComponent";
import { TagsSearchResults } from "./components/TagsSearchResults";
import { SelectTagsModalLinkModeProps } from "./types/selectMobileTags";

export const SelectTagsModalLinkMode: FC<SelectTagsModalLinkModeProps> = ({
  headerTag,
  searchText,
  load,
  displayedTags,
  filteredTags,
  getGrouping,
  onTagSelect,
  shouldVisibleEducationCategory,
  isMobileMenu,
  viewAllTags,
  isEdit,
  onMoreClick,
  showAllTagsInGroup,
  isTagEditor,
  t,
  theme,
  mainSearchRef,
  tagsScrollRef,
}) => {
  const dispatch = useDispatch();
  const modal = useModal();
  const isSuperPuper = AppTester.isSuperPuper();

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    str?.length > 1 && dispatch(TagsActions.setSearchText(str));
    str?.length === 0 && dispatch(TagsActions.setSearchText(''));
  };

  return (
    <TagsSearchScrollWrapper ref={tagsScrollRef}>
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!headerTag && !isMobileMenu && (
          <TagsSearchTitle color={theme?.tagSearch?.titleColor}>
            {t(isTagEditor ? "tag_editor" : "select")}
            {isSuperPuper && <CloseIcon onClick={() => modal.hide()} />}
          </TagsSearchTitle>
        )}
        {headerTag && <CategoryHeader headerTag={headerTag} />}
        <TagsSearchInputComponent
          mainSearchRef={mainSearchRef}
          onInputText={onInputText}
          isMobileMenu={isMobileMenu}
          showCaption={true}
        />
        {load && (
          <EmptyTextWrapper
            directionMobile="column"
            gy={24}
            width="100vw"
            align="center"
            justify="center"
            isMobileMenu={isMobileMenu}
          >
            <LoaderSpinner
              color={theme?.selectContextModal?.loaderText}
              text={t('project_edit.modal.load_msg_tag')}
            />
          </EmptyTextWrapper>
        )}
        <TagsSearchResults
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          load={load}
          isEdit={isEdit}
          onMoreClick={onMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          t={t}
        />
      </TagsSearchModalContainer>
    </TagsSearchScrollWrapper>
  );
};
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import {
  TagsSearchModalContainer,
  TagsSearchScrollWrapper,
} from "./styles.mobile";
import { CategoryHeader } from "./CategoryHeader";
import { useDispatch } from "react-redux";
import { TagsActions } from "shared/reducers/Tags";
import { EmptyTextWrapper } from "./FoundTags";
import { LoaderSpinner } from "../artzLegalsModal/LoaderAnimation";
import { TagsSearchTitle } from "./styles.mobile";
import CloseIcon from "../../icons/CloseIcon";
import { useModal } from "../../../core";
import { AppTester } from 'supporting';
import { TagsSearchInputComponent } from "./components/TagsSearchInputComponent";
import { TagsSearchResults } from "./components/TagsSearchResults";
import { SelectTagsModalLinkModeProps } from "./types/selectMobileTags";

export const SelectTagsModalLinkMode: FC<SelectTagsModalLinkModeProps> = ({
  headerTag,
  searchText,
  load,
  displayedTags,
  filteredTags,
  getGrouping,
  onTagSelect,
  shouldVisibleEducationCategory,
  isMobileMenu,
  viewAllTags,
  isEdit,
  onMoreClick,
  showAllTagsInGroup,
  isTagEditor,
  t,
  theme,
  mainSearchRef,
  tagsScrollRef,
}) => {
  const dispatch = useDispatch();
  const modal = useModal();
  const isSuperPuper = AppTester.isSuperPuper();

  const onInputText = (e: any) => {
    const str = e.target.value.trim();
    str?.length > 1 && dispatch(TagsActions.setSearchText(str));
    str?.length === 0 && dispatch(TagsActions.setSearchText(''));
  };

  return (
    <TagsSearchScrollWrapper ref={tagsScrollRef}>
      <TagsSearchModalContainer isMobileMenu={isMobileMenu}>
        {!headerTag && !isMobileMenu && (
          <TagsSearchTitle color={theme?.tagSearch?.titleColor}>
            {t(isTagEditor ? "tag_editor" : "select")}
            {isSuperPuper && <CloseIcon onClick={() => modal.hide()} />}
          </TagsSearchTitle>
        )}
        {headerTag && <CategoryHeader headerTag={headerTag} />}
        <TagsSearchInputComponent
          mainSearchRef={mainSearchRef}
          onInputText={onInputText}
          isMobileMenu={isMobileMenu}
          showCaption={true}
        />
        {load && (
          <EmptyTextWrapper
            directionMobile="column"
            gy={24}
            width="100vw"
            align="center"
            justify="center"
            isMobileMenu={isMobileMenu}
          >
            <LoaderSpinner
              color={theme?.selectContextModal?.loaderText}
              text={t('project_edit.modal.load_msg_tag')}
            />
          </EmptyTextWrapper>
        )}
        <TagsSearchResults
          displayedTags={displayedTags}
          filteredTags={filteredTags}
          getGrouping={getGrouping}
          onTagSelect={onTagSelect}
          shouldVisibleEducationCategory={shouldVisibleEducationCategory}
          isMobileMenu={isMobileMenu}
          viewAllTags={viewAllTags}
          load={load}
          isEdit={isEdit}
          onMoreClick={onMoreClick}
          showAllTagsInGroup={showAllTagsInGroup}
          isTagEditor={isTagEditor}
          t={t}
        />
      </TagsSearchModalContainer>
    </TagsSearchScrollWrapper>
  );
};
